import { Modal } from "../Modal";
import type { ShortcutHint } from "../../lib/hooks/useListNavigation";

/** The `?` overlay: every shortcut the page offers, as key → action. */
export function ShortcutHelp({
  open,
  onClose,
  shortcuts,
}: {
  open: boolean;
  onClose: () => void;
  shortcuts: ShortcutHint[];
}) {
  return (
    <Modal open={open} onClose={onClose} title="Keyboard shortcuts" widthClass="modal--confirm">
      <table className="w-full text-sm">
        <tbody>
          {shortcuts.map((s) => (
            <tr key={s.label}>
              <td className="py-1.5 pr-4 whitespace-nowrap">
                {s.keys.map((k, i) => (
                  <span key={k}>
                    {i > 0 ? <span className="text-ink-low"> or </span> : null}
                    <kbd className="kbd">{k}</kbd>
                  </span>
                ))}
              </td>
              <td className="py-1.5 text-ink-medium">{s.label}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </Modal>
  );
}

/** One-line hint for a filter bar: "Press ? for shortcuts". */
export function ShortcutHint() {
  return (
    <span className="text-xs text-ink-low hidden md:inline">
      Press <kbd className="kbd">?</kbd> for shortcuts
    </span>
  );
}
